import React from 'react';
import Layout from '../pages/Layout/Layout';
import { useNavV6 } from './useNavV6';

/**
 * Pages that render WITHOUT the platform shell today (/remote-control, /hardware/scenes, /loyalty/*) are drawn
 * inside the normal shell when the new navigation is on; with it off (and for restaurant accounts) the page is
 * returned untouched. Inner <Layout>s (their locked states) are neutralised by Layout's own shell check.
 */
export default function ShellOnNav({ children }) {
  const on = useNavV6();
  return on ? <Layout padding={false}>{children}</Layout> : children;
}
